import React, { Component, ComponentElement } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Theme, ThemeOptions } from '@material-ui/core/styles/createMuiTheme';
import createMuiTheme from './createMyTheme';
import CssBaseline from '@material-ui/core/CssBaseline';
import * as themeMyPAT from './material-ui-theme.json';

let themeMyPAT2:ThemeOptions = JSON.parse(JSON.stringify(themeMyPAT)).default;

// init theme with default config
let theme: Theme = createMuiTheme(themeMyPAT2);

// update theme to override
// TODO: Add theme modification below
theme = {
  ...theme,
  overrides: {
    ...theme.overrides,
    MuiButton: {
      root: {
        height: theme.spacing.unit * 4.5,
        padding: `0 ${theme.spacing.unit * 2}px`,
        textTransform: 'initial',
      },
      sizeSmall: {
        height: theme.spacing.unit * 3.5,
        //padding: `0 ${theme.spacing.unit * 2}px`,
        padding: 0,
        marginBottom: 0,
      },
      text: {
        padding: `0 ${theme.spacing.unit * 2}px`,
      },
      contained: {
        padding: `0 ${theme.spacing.unit * 2}px`,
      },
      outlined: {
        padding: `0 ${theme.spacing.unit * 2}px`,
      },
      containedPrimary: {
        padding: `0 ${theme.spacing.unit * 2}px`,
        background: '#1D7DEA',
        backgroundColor: '#1D7DEA !important',
        color: '#fff',
        fontWeight: 600,
        '&$disabled': {
          opacity: 0.41,
          color: 'white',
        },
        boxShadow: '0px 0px'
      },
      
    },
    MuiTabs: {
      root: {
        minHeight: theme.spacing.unit * 4.5,
      },
    },
    MuiTab: {
      root: {
        padding: theme.spacing.unit * 2,
        textTransform: 'initial',
        fontWeight: 400,
        '@media (min-width: 960px)': {
          fontSize: theme.typography.h6.fontSize,
        }
      },
      textColorInherit: {
        color: theme.palette.text.secondary,
      },
      selected: {
        color: theme.palette.text.primary,
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: 20,
        verticalAlign: 'middle',
      },
    },   
  },
  
};

function withRoot(Component : any) {
  function WithRoot(props: any) {
    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...props} />
      </MuiThemeProvider>
    );
  }

  return WithRoot;
}

export default withRoot;